import { Dialog } from '@headlessui/react'
import { ExclamationTriangleIcon, ArrowTrendingUpIcon, ArrowTrendingDownIcon } from '@heroicons/react/24/outline'

export default function ConfirmPlanChangeDialog({ isOpen, onClose, planName, isUpgrade, onConfirm }) {
  const Icon = isUpgrade ? ArrowTrendingUpIcon : ArrowTrendingDownIcon;
  const iconClass = isUpgrade ? 'text-green-600' : 'text-orange-600';
  const bgClass = isUpgrade ? 'bg-green-100' : 'bg-orange-100';
  const actionClass = isUpgrade ? 'bg-green-600 hover:bg-green-500' : 'bg-orange-600 hover:bg-orange-500';
  const actionText = isUpgrade ? 'Upgrade' : 'Downgrade';

  const getMessage = () => {
    if (isUpgrade) {
      return (
        <>
          <p className="text-sm text-gray-600 mb-2">
            Are you sure you want to upgrade to the <span className="font-semibold">{planName}</span> plan?
          </p>
          <p className="text-sm text-gray-500">
            Your upgrade will take effect immediately. You'll be charged the full amount for the new plan, and we'll add your new credits right away. As a bonus, we'll extend the renewal date for both your existing and new credits. 🎉
          </p>
        </>
      );
    }
    return (
      <>
        <p className="text-sm text-gray-600 mb-2">
          Are you sure you want to downgrade to the <span className="font-semibold">{planName}</span> plan?
        </p>
        <p className="text-sm text-gray-500">
          Your plan will change at the start of your next billing cycle. You'll continue to enjoy your current plan's benefits until then.
        </p>
      </>
    );
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-10">
      <div className="fixed inset-0 bg-gray-500/75 transition-opacity" />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
            <div className="sm:flex sm:items-start">
              <div className={`mx-auto flex size-12 shrink-0 items-center justify-center rounded-full ${bgClass} sm:mx-0 sm:size-10`}>
                <Icon className={`size-6 ${iconClass}`} />
              </div>
              <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <Dialog.Title as="h3" className="text-base font-semibold text-gray-900">
                  Confirm Plan {actionText}
                </Dialog.Title>
                <div className="mt-2">
                  {getMessage()}
                </div>
              </div>
            </div>
            <div className="mt-5 sm:ml-10 sm:mt-4 sm:flex sm:pl-4">
              <button
                type="button"
                onClick={onConfirm}
                className={`inline-flex w-full justify-center rounded-md ${actionClass} px-3 py-2 text-sm font-semibold text-white shadow-sm sm:w-auto`}
              >
                {actionText} to {planName}
              </button>
              <button
                type="button"
                onClick={onClose}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:ml-3 sm:mt-0 sm:w-auto"
              >
                Cancel
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  )
} 